/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClassroomUtilizationRow } from './ClassroomUtilizationRow';
import {
    ClassroomUtilizationRowFromJSON,
    ClassroomUtilizationRowFromJSONTyped,
    ClassroomUtilizationRowToJSON,
    ClassroomUtilizationRowToJSONTyped,
} from './ClassroomUtilizationRow';

/**
 * 
 * @export
 * @interface WidgetDataClassroomUtilizationWidgetData
 */
export interface WidgetDataClassroomUtilizationWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataClassroomUtilizationWidgetData
     */
    $type?: WidgetDataClassroomUtilizationWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<ClassroomUtilizationRow>}
     * @memberof WidgetDataClassroomUtilizationWidgetData
     */
    items: Array<ClassroomUtilizationRow>;
}


/**
 * @export
 */
export const WidgetDataClassroomUtilizationWidgetDataTypeEnum = {
    ClassroomUtilization: 'classroom-utilization'
} as const;
export type WidgetDataClassroomUtilizationWidgetDataTypeEnum = typeof WidgetDataClassroomUtilizationWidgetDataTypeEnum[keyof typeof WidgetDataClassroomUtilizationWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataClassroomUtilizationWidgetData interface.
 */
export function instanceOfWidgetDataClassroomUtilizationWidgetData(value: object): value is WidgetDataClassroomUtilizationWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataClassroomUtilizationWidgetDataFromJSON(json: any): WidgetDataClassroomUtilizationWidgetData {
    return WidgetDataClassroomUtilizationWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataClassroomUtilizationWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataClassroomUtilizationWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(ClassroomUtilizationRowFromJSON)),
    };
}

export function WidgetDataClassroomUtilizationWidgetDataToJSON(json: any): WidgetDataClassroomUtilizationWidgetData {
    return WidgetDataClassroomUtilizationWidgetDataToJSONTyped(json, false);
}

export function WidgetDataClassroomUtilizationWidgetDataToJSONTyped(value?: WidgetDataClassroomUtilizationWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(ClassroomUtilizationRowToJSON)),
    };
}

